import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import cognito from "./cognito";
import vueMixin from "./common/common_func";
Vue.mixin(vueMixin);
Vue.config.productionTip = false;

new Vue({
  router,
  cognito,
  store,
  render: h => h(App)
}).$mount("#app");
